import { Injectable } from '@angular/core';
import {
  BasePageMetaResolver,
  CanonicalPageResolver,
  PageDescriptionResolver,
  PageLinkService,
  PageRobotsResolver,
  PageTitleResolver,
  Product,
  ProductPageMetaResolver,
  ProductService,
  RoutingService,
  TranslationService,
  WindowRef
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class CustomProductPageMetaResolver
  extends ProductPageMetaResolver
  implements
  PageDescriptionResolver,
  PageTitleResolver,
  CanonicalPageResolver,
  PageRobotsResolver {

  constructor(
    protected routingService: RoutingService,
    protected productService: ProductService,
    protected translation: TranslationService,
    protected basePageMetaResolver: BasePageMetaResolver,
    protected pageLinkService: PageLinkService,
    protected winRef: WindowRef,
  ) {
    super(routingService, productService, translation, basePageMetaResolver, pageLinkService);
  }

  resolveDescription(): Observable<string> {
    return this.product$.pipe(
      switchMap((p: Product) => {
        const metaDescriptionProdOhgar = p?.metadescriptionOhgar;
        let title: string;
        if (!metaDescriptionProdOhgar) {
          title = p.description;
        } else if (metaDescriptionProdOhgar === '$longDescriptionOhgar') {
          title = p?.description;
        } else {
          title = metaDescriptionProdOhgar;
        }
        title = title?.replace(/(&nbsp;)/g, '');
        title = title?.replace(/(\r\n|\n|\r)/gm, '');
        return this.translation.translate('pageMetaResolver.product.description', {
          description: title?.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 150),
        })
      })
    );
  }

  resolveCanonicalUrl(): Observable<string> {
    return this.product$.pipe(
      switchMap((p: Product) => this.findBaseProduct(p)),
      filter((p: Product) => Boolean(p)),
      take(1),
      map((product: Product) => {
        if (product?.customCanonicalUrl) {
          const currentUrl = this.winRef.document.location.href || '';
          return this.generateCanonicalUrl(currentUrl, product.customCanonicalUrl.url);
        }
        const url = this.routingService.getFullUrl({
          cxRoute: 'product',
          params: product,
        });
        return this.pageLinkService.getCanonicalUrl({}, url);
      })
    );
  }


  private generateCanonicalUrl(currentUrl: string, newUrl: string): string {
    currentUrl = currentUrl.substring(0, currentUrl.indexOf('/p/'));
    return currentUrl + newUrl;
  }
}
